/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { H2 } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import FAQItem from 'components/core/FAQ/FAQItem';
import markdownToText from 'utils/renderMarkdownToText';

import './faq.scss';

export function FAQ({
	className,
	content = [],
	faqSchema: faqSchemaProp,
	noHeader,
	type,
	header,
}) {
	const faqSchema =
		faqSchemaProp === false
			? null
			: JSON.stringify({
					'@context': 'http://schema.org',
					'@type': 'FAQPage',
					mainEntity: content.map((faq) => ({
						'@type': 'Question',
						name: markdownToText(faq.question),
						acceptedAnswer: {
							'@type': 'Answer',
							text: faq.answer,
						},
					})),
				});

	return (
		<div className={classnames(className, 'faq')}>
			<Container>
				{!noHeader && (
					<H2
						className="faq-header sf-type-large"
						weight="ultraBold"
					>
						{header || 'Frequently asked questions'}
					</H2>
				)}

				<div className="faq-list">
					<div className="col">
						{content.map(({ question, answer, icon }, i) => (
							<FAQItem
								icon={icon}
								question={question}
								answer={answer}
								key={i}
								type={type}
							/>
						))}
					</div>
					{faqSchema && (
						<script
							key="schema"
							type="application/ld+json"
							dangerouslySetInnerHTML={{
								__html: faqSchema,
							}}
						/>
					)}
				</div>
			</Container>
		</div>
	);
}

FAQ.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	faqSchema: PropTypes.string,
	noHeader: PropTypes.bool,
	type: PropTypes.string,
	header: PropTypes.string,
};

export default FAQ;
